module.exports = __webpack_public_path__ + "static/media/xfinity-verticle-short-fre.57fc3eff.png";